import { LUNCH_OPTIONS } from "../lib/timecard";

// Escolha do tempo de almoco, em botoes grandes (como na Procore).
export default function LunchPicker({ value, onChange, disabled = false }) {
  const options = LUNCH_OPTIONS.includes(value) ? LUNCH_OPTIONS : [...LUNCH_OPTIONS, value].sort((a, b) => a - b);
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(56px,1fr))] gap-2" role="radiogroup" aria-label="Lunch time">
      {options.map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          disabled={disabled}
          onClick={() => onChange(n)}
          className={`flex h-14 flex-col items-center justify-center rounded-lg border disabled:opacity-50 ${
            value === n ? "border-primary bg-primary/15 text-primary" : "border-border"
          }`}
          data-testid={`lunch-${n}`}
        >
          <span className="text-lg font-bold leading-none">{n}</span>
          <span className="mt-1 font-mono text-[10px] uppercase tracking-widest opacity-70">min</span>
        </button>
      ))}
    </div>
  );
}
